import { createSlice } from "@reduxjs/toolkit";
import { EMPTY_FILTER_VALUES } from "../../utils/filters";
const initialState = { byContext: {} };
const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setFilters: (state, action) => {
            state.byContext[action.payload.context] = action.payload.values;
        },
        clearFilters: (state, action) => {
            delete state.byContext[action.payload];
        },
    },
});
export const { setFilters, clearFilters } = filtersSlice.actions;
/**
 * The context's filters, or an empty set.
 *
 * Returns the shared `EMPTY_FILTER_VALUES` rather than a fresh `{ player: {} }`
 * so an unfiltered context keeps the same reference across renders — several
 * callers pass this straight into effect dependencies.
 */
export const filtersForSelector = (context) => (state) => state.filtersReducer.byContext[context] ?? EMPTY_FILTER_VALUES;
export default filtersSlice.reducer;
//# sourceMappingURL=filtersSlice.js.map